import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { shapes } from '@unite-us/client-utils';
import { Spinner } from 'common/spinners';
import { DynamicTable } from 'common/tables';
import firstLine from 'common/utils/firstLine';
import CaseRowIcon from 'src/components/Dashboard/components/Cases/CaseRowIcon';
import _ from 'lodash';
import { showFacesheetCasesTableDescription } from 'common/utils/FeatureFlags/flags';
import {
  networkColumn,
  clientNameColumn,
  serviceTypeColumn,
} from '../../utils/columnConfigs/baseColumns';
import { createSortColumns } from '../../utils/columnConfigs/sortColumns';
import FilterBar from '../FilterBar';

export function AllExternalCasesIndex(props) {
  const {
    data,
    filters,
    initialSort,
    isCaseMgmtProvider,
    isCC,
    isFetching,
    isSuperNetwork,
    onCellClick,
    onFiltersChange,
    onNextClick,
    onPrevClick,
    paging,
    fetchGroupsUsers,
    showDescription,
    sortConfig,
    setSort,
  } = props;

  const onSortColumn = (column, sortDirection) => {
    if (sortConfig) {
      sortConfig(column, sortDirection);
    }
  };

  function getColumns() {
    const descColumn = {
      label: 'Description',
      formatData: (item) => firstLine(item.description),
      className: 'truncate',
    };

    const sortColumns = createSortColumns(setSort, onSortColumn);

    const baseColumns = [
      ...(isCC ? [networkColumn(isSuperNetwork, 'network.name')] : []),
      clientNameColumn(setSort, onSortColumn),
      {
        label: 'Managing Organization',
        sortColumn: 'provider.name',
      },
      ...(showDescription ? [descColumn] : []),
      serviceTypeColumn(),
      {
        label: 'Status',
        sortColumn: 'status',
        formatData: (item) => (_.isEmpty(item.outcome) ? 'Open' : 'Closed'),
        type: 'status',
      },
      ...sortColumns,
    ];

    return _.compact(baseColumns);
  }

  return (
    <div>
      <FilterBar
        filters={filters}
        onFiltersChange={onFiltersChange}
        paging={paging}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        isFetching={isFetching && !_.isEmpty(data)}
        asyncSearch={fetchGroupsUsers}
      />
      <div className="dashboard-inner-content">
        {
          (isFetching && _.isEmpty(data)) ?
            <Spinner /> : (
              <DynamicTable
                caption="All external cases"
                id="all-network-cases-table"
                dataSet={data}
                onCellClick={onCellClick}
                initialSort={initialSort}
                columnLabels={getColumns()}
                rowIcon={(serviceCase) => (
                  <CaseRowIcon
                    isCaseMgmtProvider={isCaseMgmtProvider}
                    serviceCase={serviceCase}
                  />
                )}
                emptyMessage="There are no cases."
              />
            )
        }
      </div>
    </div>
  );
}

AllExternalCasesIndex.propTypes = {
  data: PropTypes.array.isRequired,
  filters: PropTypes.array,
  initialSort: PropTypes.object,
  isCaseMgmtProvider: PropTypes.bool,
  isCC: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isSuperNetwork: PropTypes.bool,
  onCellClick: PropTypes.func.isRequired,
  onFiltersChange: PropTypes.func,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
  paging: shapes.paging,
  fetchGroupsUsers: PropTypes.func.isRequired,
  showDescription: PropTypes.bool,
  sortConfig: PropTypes.func,
  setSort: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    showDescription: showFacesheetCasesTableDescription(state),
  };
}

export default connect(mapStateToProps)(AllExternalCasesIndex);
